


























































































































import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class AppFooter extends Vue {
  @Prop({ default: true }) contacts!: boolean;
  @Prop({ default: false }) fixed!: boolean;
  get lang() {
    return this.$store.state.lang.data;
  }

  get currentYear() {
    const date = new Date();
    return date.getFullYear();
  }
}
